// State aplikasi yang dibagi antar-layar.
export const S = {
  nama: '',
  akun: '',          // id akun (lib/akun.js); sama di perangkat ini walau namanya berganti
  offline: false,
  konten: null,      // hasil muatKonten()
  mapel: 'matematika',
  jumlah: 30,
  qs: [], i: 0, rec: [],
  tStart: 0, quizStart: 0, tick: null, answered: false,
  sound: true,
  latihanModul: null, // { topik, jumlah, modul } bila ronde dimulai dari menu belajar
};
import { esc } from '../core/format.js';
// Nama panggilan (kata pertama) yang sudah di-escape, untuk disisipkan ke teks.
export const panggil = () => esc((S.nama || 'kamu').trim().split(/\s+/)[0]);
export const mapelAktif = () => S.konten.config.mapel.find(m => m.id === S.mapel);
